import axios from "axios";
import BASEURL from "../../../setBaseUrl.js";
console.log(BASEURL);

/**
 * @HttpUtil HttpUtil(url, options);
 * @param url {*} 请求地址
 * @param options.method {*} 请求方式
 * @param options.header {*} 请求头
 * @param options.responseType {*} 响应数据类型
 * @param options.params {*} 将与请求一起发送的 URL 参数
 * @param options.data {*} 作为请求主体被发送的数据 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
 */

function HttpUtil(
  url = "",
  {
    method = "GET",
    header = {
      "content-type": "application/json"
    },
    responseType = "json",
    params,
    data
  } = {}
) {
  return new Promise((resolve, reject) => {
    console.log(BASEURL + url);
    axios
      .request({
        method,
        headers: header,
        // url: process.env.BASEURL + url,
        url: BASEURL + url,
        params: params,
        data: data,
        responseType
      })
      .then(res => {
        if (res.status === 200) {
          resolve(res.data);
        } else {
          reject(res);
        }
      });
  });
}
export default HttpUtil;
